import { Component, Input, OnInit } from '@angular/core';
import {ParentService} from '@app/dashboard/services/parent.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-gabadoo',
  templateUrl: './gabadoo.page.html',
  styleUrls: ['./gabadoo.page.scss']
})
export class GabadooPage implements OnInit {
  // tslint:disable-next-line:ban-types
  isMobileDevice: Boolean;

  // tslint:disable-next-line:variable-name
  constructor(private parentService: ParentService, private toastr : ToastrService) {
    this.isMobileDevice = true;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
      this.isMobileDevice = true;
    } else {
      // this.isMobileDevice = false;
    }
  }

  ngOnInit(): void {
  }


}
